module.exports = __webpack_public_path__ + "img/note-book.27dc8515.svg";